import { makeObservable, observable, action } from "mobx";

/**
 * @template TData
 */
class SmrTableStore {
    /** @type {TData[]} */
    data;
    paginationInfo;

    /**
     * @param {number} [elementsPerPage]
     */
    constructor(elementsPerPage) {
        makeObservable(this, {
            data: observable,
            paginationInfo: observable,
            CleanStore: action,
            HandlePagination: action
        });

        if (elementsPerPage == undefined || elementsPerPage < 10)
            elementsPerPage = 10;

        this.data = [];
        this.paginationInfo = {
            elementsPerPage: elementsPerPage,
            currentPage: 1,
            pageCount: 1,
            firstPageEnabled: false,
            prevPageEnabled: false,
            nextPageEnabled: false,
            lastPageEnabled: false
        };
    };

    CleanStore = action(() => {
        this.data = [];
        this.paginationInfo = {
            elementsPerPage: this.paginationInfo.elementsPerPage,
            currentPage: 1,
            pageCount: 1,
            firstPageEnabled: false,
            prevPageEnabled: false,
            nextPageEnabled: false,
            lastPageEnabled: false
        };
    });

    HandlePagination = action((SetPageData, recordsFiltered, pageToSet, ReloadData) => {
        let pageCount = parseInt(recordsFiltered / this.paginationInfo.elementsPerPage);

        if (pageCount === 0)
            pageCount = 1;

        pageCount = (recordsFiltered > this.paginationInfo.elementsPerPage &&
            recordsFiltered % this.paginationInfo.elementsPerPage) > 0 ? pageCount + 1 : pageCount;

        if (pageToSet > pageCount) {
            ReloadData(pageCount);
            return false;
        }

        SetPageData(pageToSet);

        this.paginationInfo = {
            elementsPerPage: this.paginationInfo.elementsPerPage,
            currentPage: pageToSet,
            pageCount: pageCount,
            firstPageEnabled: pageToSet !== 1,
            prevPageEnabled: pageToSet !== 1,
            nextPageEnabled: pageToSet !== pageCount,
            lastPageEnabled: pageToSet !== pageCount
        };

        return true;
    })
}

export default SmrTableStore;